var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colour-pick"},[_c('swatches',{attrs:{"colors":"text-advanced","show-fallback":"","fallbackInputClass":"custom-colour-fallback","fallback-input-type":"color","popover-to":"left","row-length":"10","swatch-size":"32","swatch-style":{ borderRadius: '10px', padding: '16px 10px' }},model:{value:(_vm.form[_vm.id]),callback:function ($$v) {_vm.$set(_vm.form, _vm.id, $$v)},expression:"form[id]"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618569ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ColourPicker.vue
// module id = 593
// module chunks = 0